import { AbstractTestDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTestDisplayProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
/**
 * Game-specific properties for the test area display.
 */
export class GameTestDisplayProperties extends AbstractTestDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.testButtonProperties.textFieldProperties.size = new Point(150, 120);
        this.testButtonProperties.textFieldProperties.multiline = true;
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameTestDisplayProperties.js.map